import Feedback from './Feedback';
import './Feedback.scss';

export default Feedback;
